//----- 枚举 Start -----//
export enum TextEnum { // 文案
  Undeveloped = '暂未开发，敬请期待',
  SelectDefault = '--请选择--',
  SaveImagePC = '右键图片保存',
  ShareImagePC = '右键图片，保存分享',
  SaveImageMobile = '长按图片保存',
  ShareImageMobile = '长按图片，保存分享',
  
  // 成功
  SuccessLogin = '登录成功',
  SuccessLogout = '退出成功',
  SuccessRegister = '注册成功',
  SuccessGet = '获取成功',
  SuccessRevise = '修改成功',
  SuccessShare = '分享成功',
  
  // 错误
  ErrorCheckFail = '验证失败，请检测输入信息',
  ErrorFrequently = '请勿频繁操作',
  ErrorNetwork = '网络波动，请稍后再试',
  
  // 操作
  OperateFreeUse = '点击免费试用产品按钮',
  OperateReserve = '点击预约演示按钮',
  OperateGSS = '点击前往GSS系统',
  OperateOverseasSubmit = '海外用户提交信息'
}

export enum CookieEnum { // Cookie
  Token = 'GFToken', // 会话
  UserID = 'GFUserID', // 用户ID
  UserName = 'GFUserName', // 用户名
  Source = 'GFSource', // 源地址
  SourceAccess = 'GFSourceAccess' // 访问源地址
}

export enum StorageEnum { // Storage
  Language = 'GFLanguage',
  PointPlan = 'GFPointPlan',
  PointNews = 'GFPointNews',
  PointCompany = 'GFPointCompany'
}

export enum ParamEnum { // 参数
  Token = 'gf_token', // 会话
  UserID = 'gf_userid', // 用户ID
  UserName = 'gf_username', // 用户名
  Source = 'gf_source', // 源地址
  SourceAccess = 'utm_source', // 访问源地址
  Operate = 'gf_operate' // 操作
}

export enum RouterEnum { // 路由
  All = '/:pathMatch(.*)*',
  Root = '/',
  Index = '/index',
  
  // 页面
  Page = '/page',
  Home = '/home',
  Database = '/database',
  Consult = '/consult',
  About = '/about',
  Community = '/community',
  ProductSchedulX = '/productSchedulX',
  // ProductSchedulXSaaS = '/productSchedulXSaaS',
  ProductCostPilot = '/productCostPilot',
  ProductInfraPilot = '/productInfraPilot',
  ProductAIPilot = '/productAIPilot',
  ProductAidigitalHuman = '/productAidigitalHuman',
  ProductPrivateAidigitalHuman = '/productPrivateAidigitalHuman', 
  PlanOperation = '/planOperation',
  PlanTrusteeship = '/planTrusteeship',
  PlanCost = '/planCost',
  PlanStable = '/planStable',
  PlanMigrate = '/planMigrate',
  PlanActive = '/planActive',
  News = '/news',
  NewsDetail = '/newsDetail',
  License = '/license',
  
  // 白皮书
  Book = '/book',
  BookIndustry = '/book/industry',
  BookCostOptimization = '/book/costOptimization',
  BookDevOps = '/book/devOps',
  
  // 海外
  OverseasEN = '/en',
  OverseasENHome = '/en/home'
}

export enum SSOEnum { // SSO
  Index = 'index', // 首页
  Register = 'register', // 注册
  Login = 'login', // 登录
  Logout = 'logout', // 退登
  Replenish = 'replenish', // 完善
  Back = 'back' // 返回
}

export enum CodeEnum { // 服务器
  Normal = 200, // 正常
  ErrorParam = 1206, // 参数错误
  ErrorAuthReset = 1209, // 授权重置
  ErrorAuthFail = 1201, // 授权失败
  ErrorAuthExpired = 1202 // 授权过期
}

export enum GridEnum { // 栅格
  PC = 1920,
  Mobile = 750,
  XS = 576,
  SM = 576,
  MD = 768,
  LG = 992,
  XL = 1200,
  XXL = 1600,
  XXXL = 2000
}

export enum ColorEnum { // 颜色
  Black = '#000000',
  white = '#ffffff',
  Pink = '#c41d7f',
  Red = '#cf1322',
  Orange = '#d46b08',
  Yellow = '#d4b106',
  Gold = '#d48806',
  Cyan = '#08979c',
  Lime = '#7cb305',
  Green = '#389e0d',
  Blue = '#096dd9',
  GeekBlue = '#1d39c4',
  Purple = '#531dab',
  Success = '#52c41a',
  Processing = '#1890ff',
  Error = '#f5222d',
  Warning = '#fa8c16'
}

export enum ThemeEnum { // 主题
  Light = 'light',
  Dark = 'dark'
}

export enum LanguageEnum { // 语言
  ZH = 'zh', // 中文
  ZH_CN = 'zh-CN', // 简体中文
  ZH_HK = 'zh-HK', // 繁体中文（香港）
  ZH_TW = 'zh-TW', // 繁体中文（台湾）
  EN = 'en' // 英文
}

//----- 枚举 End -----//

//----- 字典 Start -----//
export const LanguageDict: DictInterface[] = [
  {
    label: '简体中文',
    value: LanguageEnum.ZH
  },
  {
    label: 'English',
    value: LanguageEnum.EN
  }
];
//----- 字典 End -----//

//----- 接口 Start -----//
export interface DictInterface { // 字典
  label: string; // 标签
  value: any; // 值
  expand?: any; // 拓展
}

export interface DataInterface { // Vue数据
  enumType?: Record<string, any>; // 枚举类型
  dictType?: Record<string, any>; // 字典类型
  interfaceType?: Record<string, any>; // 接口类型
  href?: Record<string, any>; // 链接
  file?: Record<string, any>; // 文件
  setTime?: Record<string, number>; // 定时器
  store?: Record<string, any>; // 状态
  request?: { // 请求
    intercept?: Record<string, any>; // 拦截
    data?: Record<string, any>; // 数据
  };
  description?: any[] | Record<string, any>; // 描述
  showcase?: any[] | Record<string, any>; // 展示
  form?: { // 提交数据
    rule?: Record<string, any>; // 规则
    data?: Record<string, any>; // 数据
    cache?: null | Record<string, any>; // 缓存
  };
  table?: { // 表格
    column?: any[] | Record<string, any>; // 列
    data?: any[] | Record<string, any>; // 数据
    pagination?: Record<string, any>; // 分页
  };
  tree?: { // 树
    select?: string | string[] | Record<string, any>; // 选择项
    expand?: string[] | Record<string, any>; // 展开项
    field?: Record<string, any>; // 领域
    data?: any[] | Record<string, any>; // 数据
  };
  tab?: Record<string, any>; // 标签
  drawer?: Record<string, any>; // 抽屉
  modal?: Record<string, any>; // 模态
  chart?: Record<string, any>; // 图标
  instance?: Record<string, any>; // 实例
  expand?: Record<string, any>; // 拓展
}

export interface BaseRequestInterface { // 基础请求
}

export interface BaseResponseInterface { // 基础结果
  code: CodeEnum; // 状态码
  message?: string; // 系统信息
  msg?: string; // 业务信息
  data: any; // 数据
}

//----- 接口 End -----//